import { KalturaWatchStatus } from '../../phoenix/enums';
import type { CategoryUidaAsset } from '../compat/tvpil';

export type ContinueWatchingSettings = {
  daysSinceWatched: number;
  enableEpisodesGrouping: boolean;
  kSql: string;
  typeIn: string;
  watchingStatus: KalturaWatchStatus;
};

const DEFAULT_DAYS_SINCE_WATCHED = 50;

export function getContinueWatchingSettings(category: CategoryUidaAsset): ContinueWatchingSettings {
  return {
    daysSinceWatched: DEFAULT_DAYS_SINCE_WATCHED,
    enableEpisodesGrouping: Boolean(category.continueWatchingProperty.useSuppress),
    kSql: category.aggregatedKSQL,
    typeIn: category.continueWatchingProperty.typeIn || '',
    watchingStatus: category.continueWatchingProperty.statusEqual,
  };
}
